import http from '@/http/aisea/axios'
const resource = "/enterprises/crews";

export default {

  addPicture(enterpriseCrewId, payload) {
    return http.post(`${resource}/${enterpriseCrewId}/pictures`, payload.formData);
  },

  deletePicture(enterpriseCrewId) {
    return http.delete(`${resource}/${enterpriseCrewId}/pictures`);
  },
};
